// extracted by mini-css-extract-plugin
export default {"textField":"SingleFieldDialog_textField__frL6+"};